import {
    DATEV_EXPORTER_INTEGRATION,
    INTEGRATION_GROUPED_DOC,
    INTEGRATION_IMG,
    MULTIPLE_INVOICE_INTEGRATIONS,
    MULTIPLE_TRX_INTEGRATIONS,
    UPLOAD_INTEGRATIONS
} from 'app/common/constants';
import {IApiModel} from 'app/original-models/api-model.interface';
import moment from 'moment';

const SERVICES_LAST_SYNC_NULL = ['moss', 'datev', 'candis'];

export class IntegrationsModel implements IApiModel<IntegrationsModel> {
    id: number;
    serviceId: string;
    lastSync: any;
    connectedDate: Date;
    name: string;
    credentials: any[];
    startDate: Date;
    contracts: any[];
    currencies: any[];
    factoringRate: number;
    integrationName: string;
    title: string;
    documents: string[];
    customName?: string;
    account_name?: string;
    alias?: string;
    organization_id?: string;
    onboarding_url?: string;
    frontend_url?: string;
    status?: string;
    domain?: string;
    shop: string;
    email: string;

    getApiModel(): any {
        return undefined;
    }

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.serviceId = apiModel.service_id;
        this.onboarding_url = apiModel.onboarding_url;
        this.frontend_url = apiModel.frontend_url;
        this.status = apiModel.status;
        this.connectedDate = apiModel.date_connected ? moment(apiModel.date_connected).toDate() : null;
        this.lastSync = (apiModel.last_sync && !SERVICES_LAST_SYNC_NULL.includes(apiModel.service_id)) ? moment(apiModel.last_sync) : null;
        this.startDate = apiModel.start_date ? moment(apiModel.start_date).toDate() : null;
        this.contracts = apiModel.info && apiModel.info.contracts ? apiModel.info.contracts : [];
        this.currencies = apiModel.info && apiModel.info.currencies ? apiModel.info.currencies : [];
        this.factoringRate = apiModel.info && apiModel.info.rate ? apiModel.info.rate : null;
        this.account_name = apiModel.info && apiModel.info.account_name ? apiModel.info.account_name : null;
        this.alias = apiModel.info && apiModel.info.alias ? apiModel.info.alias : null;
        this.organization_id = apiModel.info && apiModel.info.organization_id ? apiModel.info.organization_id : null;
        this.email = apiModel.info && apiModel.info.email ? apiModel.info.email : null;
        let docCopy = JSON.parse(JSON.stringify(INTEGRATION_GROUPED_DOC))
        if ((UPLOAD_INTEGRATIONS.indexOf(apiModel.integration_name.toLowerCase()) < 0)
            || apiModel.integration_name.toLowerCase() === 'stripe') {
            if (apiModel.integration_name === 'Zoho Books') {
                apiModel.integration_name = 'Zoho';
                this.domain = apiModel?.info?.domain;
            }
            if (apiModel.service_id === 'fastbill' && !this.alias) {
                this.alias = 'FastBill';
            }
            if (apiModel.integration_name === 'Shopify') {
                this.shop = apiModel.info && apiModel.info.shop ? apiModel.info.shop : null;
            }
            let documents = docCopy[apiModel.integration_name.replace(/\s/g, '').toLowerCase()];
            if (documents) {
                this.documents = documents.map((group: any) => {
                    return {
                        group: group.group,
                        items: group.items.map((doc: any) => {
                            if (apiModel.info.types) {
                                if (!apiModel.info.types.length) {
                                    doc.checked = true;
                                } else {
                                    doc.checked = !!apiModel.info.types.find((d: string) => d === doc.true_name);
                                }
                            }
                            if (doc.statuses && doc.statuses.length > 0) {
                                for (let i = 0; i < doc.statuses.length; i++) {
                                    const status = doc.statuses[i];
                                    status.checked = apiModel.info.statuses &&
                                        apiModel.info.statuses[doc.true_name] &&
                                        apiModel.info.statuses[doc.true_name].length > 0 &&
                                        apiModel.info.statuses[doc.true_name].includes(status.value);
                                }
                            }
                            return doc;
                        })
                    };
                });
            }
        }
        this.integrationName = apiModel.integration_name;
        if (INTEGRATION_IMG[this.serviceId] && INTEGRATION_IMG[this.serviceId].title) {
            this.title = INTEGRATION_IMG[this.serviceId].title;
        } else {
            //TODO: its stupid
            this.title = apiModel.integration_name;
        }
        return this;
    }


    setFromApiModelAll(apiModel: any): this {
        this.name = apiModel.name;
        this.integrationName = apiModel.integration_name;
        if (INTEGRATION_IMG[this.name] && INTEGRATION_IMG[this.name].title) {
            this.title = INTEGRATION_IMG[this.name].title;
        } else {
            this.title = apiModel.integration_name;
        }
        if (Object.keys(apiModel.credentials).length) {
            this.credentials = Object.keys(apiModel.credentials).map((key, index) => {
                apiModel.credentials[key].label = apiModel.credentials[key].label.replace(/\b\w/g, (match) => match.toUpperCase()).replace(/\s/g, '')
                apiModel.credentials[key].key = key;
                return apiModel.credentials[key]
            });
        } else {
            this.credentials = [];
        }
        if (MULTIPLE_TRX_INTEGRATIONS.includes(apiModel.name)) {
            this.credentials.push({
                'type': 'string',
                'required': true,
                'read_only': false,
                'label': 'AccountName',
                'key': 'account_name',
                'value': null
            })
        }
        if (apiModel.name === 'getmyinvoices') {
            this.credentials.push({
                'type': 'string',
                'required': true,
                'read_only': false,
                'label': 'AccountId',
                'key': 'account_id',
                'value': null,
                'placeholder': 'Setup.Integrations.getmyinvoices.AccountIdPlaceholder'
            })
        }
        if (MULTIPLE_INVOICE_INTEGRATIONS.includes(apiModel.name)) {
            this.credentials.push({
                'type': 'string',
                'required': true,
                'read_only': false,
                'label': 'Alias',
                'key': 'alias',
                'value': null
            })
        }
        if (['shopify'].includes(apiModel.name)) {
            this.credentials.push({
                'type': 'string',
                'required': true,
                'read_only': false,
                'label': 'Shop',
                'key': 'shop',
                'value': null
            })
        }
        if (['zoho'].includes(apiModel.name)) {
            this.credentials.push({
                'type': 'string',
                'required': false,
                'read_only': false,
                'label': 'CompanyId',
                'key': 'organization_id',
                'value': null
            })
            this.credentials.push({
                'type': 'dropdown',
                'required': true,
                'read_only': false,
                'label': 'Region',
                'key': 'region',
                'defaultValue': '.eu',
                'value': null
            })
        }
         if ([DATEV_EXPORTER_INTEGRATION].includes(apiModel.name)) {
             this.credentials.push({
                'type': 'string',
                'required': true,
                'read_only': false,
                'label': 'ConsultantNumber',
                'key': 'consultant_number',
                'value': null
            })
            this.credentials.push({
                'type': 'string',
                'required': true,
                'read_only': false,
                'label': 'ClientNumber',
                'key': 'client_number',
                'value': null
            })
        }
        return this;
    }
}
